import type {ThemedVisual} from '../../../Index.types'

import Styles from './EyebrowBanner.module.css'

export interface EyebrowBannerProps {
  image: ThemedVisual
  text: string
  url: string
}

export const defaultProps: Partial<EyebrowBannerProps> = {}

export const EyebrowBanner = (props: EyebrowBannerProps) => {
  const initializedProps: EyebrowBannerProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  return <div className={Styles['EyebrowBanner']}>EyebrowBanner</div>
}
